<template>
  <div ref="isShow" class="w1200 newsBox">
    <div ref="isShowChange" class="leftBox">
      <newDetail v-if="contentData.cmsContent.TEMPLATE_NAME==='资讯'" :list="contentData" @handelRead="changeShow" @showlogin="handdelShow" />
      <atlasDetail v-if="contentData.cmsContent.TEMPLATE_NAME==='图集'" :list="contentData" @handelRead="changeShow" @showlogin="handdelShow" />
      <libraryDetail v-if="contentData.cmsContent.TEMPLATE_NAME==='文库'" :list="contentData" @handelRead="changeShow" @showlogin="handdelShow" />
      <vdoDetail v-if="contentData.cmsContent.TEMPLATE_NAME==='视频'" :list="contentData" @handelRead="changeShow" @showlogin="handdelShow" />
      <div class="speak">
        <Speak :content-id="contentData.cmsContent.CONTENT_ID" @showlogin="handdelShow" />
      </div>
    </div>
    <div class="rightBox">
      <Rightlist v-show="isShow" />
      <!--<div>11111</div>-->
    </div>
    <el-dialog
       custom-class="loginBoxs"
      :visible.sync="seelogin"
      width="850px"
      :before-close="handleClose"
    >
      <loginShow />
    </el-dialog>
  </div>
</template>
<script>
// 资讯类型
import newDetail from '@/components/DetailComponents/newsDetail.vue'
// 图集类型
import atlasDetail from '@/components/DetailComponents/atlasDetail.vue'
// 文库类型
import libraryDetail from '@/components/DetailComponents/libraryDetail.vue'
// 视频类型
import vdoDetail from '@/components/DetailComponents/vdoDetail.vue'
import Speak from '@/components/Detail_speak/index.vue'
// 右边栏
import Rightlist from '@/components/commonRightList'
import loginShow from '@/components/logincomponent/index.vue'
import { addReadSize_content } from '@/api/api.js'
import { ssoUserLogin } from '@/api/api.js'
export default {
  components: { Rightlist, newDetail, atlasDetail, libraryDetail, vdoDetail, Speak, loginShow },
  head() {
    var listObj = this.$store.state.detailData.cmsContent
    var metaStr = listObj.CONTENT_ABSTRACT
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    var keys = ''
    if (!this.$store.state.detailData.cmsContent.CONTENT_TAG) {
      if (this.contentData.cmsContent.TEMPLATE_NAME === '资讯') {
        keys = '姓氏文化，百家姓，百家姓氏大全，百家姓排行，百家姓排位，百家姓全文'
      }
      if (this.contentData.cmsContent.TEMPLATE_NAME === '图集') {
        keys = '姓氏，姓氏文化，家族图片，家族图片大全，家族图片制作，家族宣传，家族logo'
      }
      if (this.contentData.cmsContent.TEMPLATE_NAME === '文库') {
        keys = '参考资料，谱书，谱文，谱系，族谱资料，姓氏百科，姓氏文化，姓氏查询'
      }
      if (this.contentData.cmsContent.TEMPLATE_NAME === '视频') {
        keys = '姓氏，姓氏文化，家族视频，编谱视频，编谱教学，视频教学，家族宣传'
      }
    } else {
      keys = this.$store.state.detailData.cmsContent.CONTENT_TAG
    }
    return {
      title: this.contentData.cmsContent.CONTENT_TITLE + '-彭祖世家网',
      mateDesc: metaStr,
      keys: keys
    }
  },
  inject: ['reload'],
  data() {
    return {
      seelogin: false,
      isShow: true,
      title: '6666'
    }
  },
  computed: {
    contentData() {
      return this.$store.state.detailData
    }
  },
  watch: {
    $route(to, from) {
      ssoUserLogin().then(res => {
        if (res.data.userId) {
          this.setloca('userid', res.data.userId, 7200)
          localStorage.removeItem('unionid')
        } else {
          localStorage.removeItem('userid')
        }
      })
    }
  },
  asyncData({ store, route }) {
    return store.dispatch('getDetail', { contentId: route.query.contentId })
  },
  beforeCreate() {
    this.$store.dispatch('getDetail', { contentId: this.$route.query.contentId })
  },
  mounted() {
    localStorage.removeItem('isback')
    this.$nextTick(function() {
      addReadSize_content({ contentId: this.$route.query.contentId }).then(res => {

      })
    })
    window.addEventListener('beforeunload', this.fn)
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.fn)
  },
  methods: {
    // //////切换居中模式
    changeShow: function(value) {
      if (value) {
        this.isShow = false
        this.$refs.isShow.style.position = 'absolute'
        this.$refs.isShow.style.top = '0'
        this.$refs.isShow.style.width = '100%'
        this.$refs.isShow.style.backgroundColor = '#fff'
        this.$refs.isShowChange.style.marginLeft = (document.body.clientWidth - 880) / 2 + 'px'
        this.fn()
      } else {
        this.isShow = true
        this.reload()
      }
    },
    fn: function() {
      window.scrollTo(0, 0)
    },
    handdelShow: function() {
      this.seelogin = true
    },
    handleClose: function() {
      this.seelogin = false
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .newsBox{
        background-color: #fafafa;
        overflow: hidden;
        /*position: relative;*/
         margin: 0 auto;
      z-index: 10;
    }
    .leftBox{
        width: 880px;
        margin-right: 20px;
        margin-top: 20px;
        float: left;
    }
    .rightBox{
        width: 300px;
        margin-top: 20px;
        float: right;
        overflow: hidden;
    }
</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .leftBox{
      width: 100%;
      margin-top: 0;
    }
    .rightBox{
      display: none;
    }
  }
</style>

